import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init, fetching } = createAllActions(types.SCOPE);

const fetchSPIThresholds = () => ({
  type: types.FETCH_SPI_THRESHOLD,
});

// spi widgetIndex is harcoded. TODO: update logic
const setSPIThresholds = data => ({
  type: types.SET_SPI_THRESHOLD,
  config: data.kpiThresholds,
});

const saveUserKpiPreference = (payload, closePopup, shouldEdit) => {
  return {
    type: types.SAVE_USER_KPI_PREFERENCE,
    payload,
    closePopup,
    shouldEdit
  }
};

const updateCustomKPI = payload => {
  return {
    type: types.UPDATE_CUSTOM_KPI,
    payload
  }
};

const deleteCustomKPI = (payload, closePopup) => {
  return {
    type: types.DELETE_CUSTOM_KPI,
    payload,
    closePopup
  }
};

const updateSelectedConfig = payload => {
  return {
    type: types.UPDATE_SELECTED_CONFIG,
    payload
  }
}

const setSelectedKPIConfig = payload => {
  return {
    type: types.SET_SELECTED_CONFIG,
    payload
  }
}

const setEditable = flag => {
  return {
    type: types.SET_EDITABLE_FLAG,
    flag
  }
}

const saveAndApply = (payload, closePopup) => {
  return {
    type: types.SAVE_AND_APPLY,
    payload,
    closePopup
  }
}

const selectCreateNew = flag => {
  return {
    type: types.SELECT_CREATE_NEW,
    flag
  }
}

const setError = ({ errorMsg, errorCode }) => ({
  type: types.SET_ERROR,
  errorMsg,
  errorCode
});

const setFetching = ({  isFetching }) => ({
  type: types.SET_FETCHING,
  isFetching,
});

const setInitializing = ({  isInitializing }) => ({
  type: types.SET_INITIALIZING,
  isInitializing,
});

export {
  init, fetching,
  fetchSPIThresholds,
  setSPIThresholds,
  saveUserKpiPreference,
  updateCustomKPI,
  deleteCustomKPI,
  setSelectedKPIConfig,
  setEditable,
  updateSelectedConfig,
  saveAndApply,
  selectCreateNew,
  setError,
  setFetching,
  setInitializing
};
